import { DayOfWeek } from 'wizards/models/DayOfWeek.enum';
import { WeekNumber } from 'wizards/models/WeekNumber.enum';

export enum OverdueAfterSuccessPeriod {
  'Hour(s)' = 0,
  'Day(s)' = 1
}

/**
 * ffi flag Must be Keep in separated property - ForwardIncremental (GetPlan -> {plan: {ForwardIncremental: boolean}})
 */
export enum ScheduleType {
  noschedule,
  once,
  recurring,
  predefined,
  instantly,
  ffi
}

export interface IncrementalData {
  enabled: boolean;
  recurringPeriod: 'Daily' | 'Monthly';
  weeklyDayOfWeek: boolean[];
  occurrence: WeekNumber;
  dayOfWeek: DayOfWeek;
  dayOfMonthCount: number;
  dailyFreqPeriodOption: 'OccursAt' | 'OccursEvery';
  occursAtTime: string;
  occursEveryCount: number;
  occursEveryPeriod: string;
  occursEveryFromTime: string;
  occursEveryToTime: string;
  repeatEveryCount?: number;
  startFromDate?: Date | string;
}

export interface FullBackupData {
  enabled: boolean;
  recurringPeriod: 'Daily' | 'Monthly';
  weeklyDayOfWeek: boolean[];
  occurrence: WeekNumber;
  dayOfWeek: DayOfWeek;
  dayOfMonthCount: number;
  dailyFreqPeriodOption: 'OccursAt' | 'OccursEvery';
  occursAtTime: string;
  repeatEveryCount?: number;
  startFromDate?: Date | string;
}

export type ScheduleModalData = { incrementalData?: IncrementalData; fullBackupData?: FullBackupData };

export interface SyntheticFullData {
  recurringPeriod: 'Weekly' | 'Monthly';
  dayOfWeek: DayOfWeek;
  occurrence: WeekNumber;
  runMissed: boolean;
}

export const syntheticFullDefaults: SyntheticFullData = {
  recurringPeriod: 'Weekly',
  dayOfWeek: DayOfWeek.Saturday,
  occurrence: WeekNumber.First,
  runMissed: true
};

export interface ScheduleStepValue {
  oldStepLogic?: boolean;
  ScheduleType: string | keyof typeof ScheduleType;
  specificDateGroup?: {
    date: Date | string;
    time: Date | string;
  };
  StopAfterEnabled: boolean;
  stopAfterHours: number;
  stopAfterMinutes: number;
  ForceMissedSchedule?: boolean;
  overdueAfterSuccessEnabled?: boolean;
  overdueAfterSuccessAmount?: number;
  overdueAfterSuccessPeriod?: number;
  incrementalData?: IncrementalData;
  fullBackupData?: FullBackupData;
  syntheticData?: SyntheticFullData;
  syntheticRequired?: boolean;
  syncBeforeRun?: boolean;
  valid: boolean;
}
